import React, {useState} from 'react';
import PropTypes from "prop-types";
import SuggestionList from "./SuggestionList";
import useSuggestions from "../../hooks/useSuggestions";
import Searchbar from "./Searchbar";

function SearchBox({placeholder, buttonAllResults, searchUrl, noResultsText, language}) {
    const [query, setQuery] = useState("");
    const {suggestions, loading, loaded, loadSuggestions} = useSuggestions(10, language);

    const searchPageUrl = `${searchUrl}?text=${query}&type%5B%5D=producten`;

    const handleChange = async (e) => {
        setQuery(e.target.value);
        loadSuggestions(e.target.value);
    }

    return (
        <div style={{position: "relative"}}>
            <Searchbar
                value={query}
                placeholder={placeholder}
                loading={loading}
                onChange={handleChange}
                onSubmit={() => window.location.href = searchPageUrl}
            />

            {loaded ?
                <SuggestionList
                    items={suggestions.items}
                    total={suggestions.total}
                    buttonText={buttonAllResults}
                    onItemClick={(item) => window.location.href = item.url}
                    onButtonClick={() => window.location.href = searchPageUrl}
                    noResultsText={noResultsText}
                />
                : null
            }
        </div>
    );
}

SearchBox.propTypes = {
    placeholder: PropTypes.string,
    buttonAllResults: PropTypes.string,
    searchUrl: PropTypes.string,
    noResultsText: PropTypes.string,
    language: PropTypes.string.isRequired
};

export default SearchBox;